var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view')],1),_vm._v(" "),_c('main-footer'),_vm._v(" "),(_vm.debug)?_c('div',{staticClass:"debug pre-line"},[_vm._v("\n    breakpoint: "),_c('span',{staticClass:"breakpoint"}),_vm._v(" <= "+_vm._s(_vm.width)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }